import { FC, useEffect } from 'react';
import { useStoreContext } from 'store/app';
import { useTranslationsContext } from 'store/translations';
import { Button } from 'components/core';
import './ReceivedPresent.styl';

interface ReceivedPresentProps {
    imgSrc: string;
    collectionName: string;
    presentName: string;
    onCloseModal: () => void;
}

export const ReceivedPresent: FC<ReceivedPresentProps> = ({ collectionName, imgSrc, presentName, onCloseModal }) => {
    const { setExchangedSnake, exchangedSnake, logOperation } = useStoreContext();
    const { translate } = useTranslationsContext();

    useEffect(() => {
        logOperation('collections', 'change_success', exchangedSnake?.id);
    }, []);

    const onOk = () => {
        setExchangedSnake(null);
        onCloseModal();
    };

    return (
        <div className="received-present">
            <div className="received-present-card">
                <img className="received-present-card-image" src={imgSrc} alt="present" />
                <div className="received-present-card-info">
                    <span className="received-present-card-info-collection-name">{collectionName}</span>
                    <span className="received-present-card-info-present-name">{presentName}</span>
                </div>
            </div>
            <div className="received-present-text-block">
                <span className="received-present-text-block-title">{translate('exchange.complete.title')}</span>
                <span className="received-present-text-block-subtitle">{translate('exchange.complete.subtitle')}</span>
            </div>
            <Button className="received-present-btn" onClick={onOk}>
                {translate('exchange.complete.btn')}
            </Button>
        </div>
    );
};
